// extracted by css-extract-rspack-plugin
export default {"filterContainer":"Presenter__filterContainer--kP8l1","searchContainer":"Presenter__searchContainer--jo8s4"};